<template>
  <div class="img-back" v-if="item.picError">
  </div>
  <img v-bind="$attrs" @error="(e) => imgError(e, item, pic)" v-else/>
</template>

<script>
import picEmptyBig from '../assets/img/pic_empty_big.png'
export default {
  name: '',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    pic: {
      type: String,
      default: 'coverUrl'
    }
  },
  data () {
    return {
      picEmptyBig
    }
  },
  methods: {
    imgError (e, item, attr) {
      item[attr] = picEmptyBig
      item.picError = true
    }
  }
}
</script>

<style lang="scss" scoped>
.img-back {
  background-image: url(../assets/img/pic_empty_big.png);
  background-size: 106%;
  background-position: center center;
  height: 100%;
}
</style>
